
export enum AuthType
{
    SignUp = 0,
    SignIn = 1,
    ForgotPass = 2,
}